




























import Vue from 'vue';
import Component from 'vue-class-component';

import PageContainer from '@/general/component/PageContainer.vue';

import RadioGroup from '@/general/component/form/input/RadioGroup.vue';
import { Api } from '@/common/api/Api';

import TextInput from '@/general/component/form/input/TextInput.vue';
import CalculationRouter from '@/context/calculation/router/CalculationRouter';
import { CalculationApi } from '@/context/calculation/api/CalculationApi';
import { CalculationFilter } from '@/context/calculation/model/CalculationFilter';
import ItemPredicate from "@/common/model/ItemPredicate";

@Component({
  computed: {
    ItemPredicate() {
      return ItemPredicate
    }
  },
  components: {
    RadioGroup,
    PageContainer,
    TextInput
  }
})
export default class CalculationRequestListContainer extends Vue {
  router: CalculationRouter = CalculationRouter.instance();
  filter: CalculationFilter = new CalculationFilter();
  entityHeaders: Array<Record<string, unknown>> = [
    {
      text: "Status",
      value: "status",
      align: "left"
    },
    {
      text: "Start",
      value: "start",
      align: "left"
    },
    {
      text: "End",
      value: "end",
      align: "left"
    }
  ];
  commonHeaders: Array<Record<string, unknown>> = [
    {
      text: "Id",
      value: "id",
      align: "left"
    },
    {
      text: "Operacje",
      value: "actions",
      align: "left"
    }
  ];
  api: Api = CalculationApi.instance();

  getStatusColor(status: string) {
    switch (status) {
      case "IN_QUEUE":
        return "info";
      case "IN_PROGRESS":
        return "orange";
      case "PROCESSED":
        return "green";
    }
  }
}
